import { ConfigProvider } from "antd";
import frFR from "antd/locale/fr_FR";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { frFR as muiFrFR } from "@mui/x-date-pickers/locales";
import "../utils/frenchLocale";

const frenchLocale = {
  ...frFR,
  DatePicker: {
    ...frFR.DatePicker,
    lang: { ...frFR.DatePicker.lang,
      fieldDateFormat: "DD/MM/YYYY",
      fieldDateTimeFormat: "DD/MM/YYYY HH:mm",
      fieldTimeFormat: "HH:mm",
      fieldWeekFormat: "[Semaine] WW/YYYY",
      fieldMonthFormat: "MM/YYYY",
      today: "Aujourd’hui",
      now: "Maintenant",
    },
  },
};

export default function FrenchLocaleProvider({ children }) {
  return <ConfigProvider locale={frenchLocale}>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr"
      localeText={muiFrFR.components.MuiLocalizationProvider.defaultProps.localeText}>
      {children}
    </LocalizationProvider>
  </ConfigProvider>;
}
